/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Variable({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeWidth={1.2}><rect width={5.215} height={5.215} x={10.146} y={9.602} rx={1} /><rect width={5.215} height={5.215} x={1.568} y={9.602} rx={2.607} /><path strokeLinecap="round" strokeLinejoin="round" d="M10.515 1.184h1.14l2.085 4.893h1.252" /><path strokeLinecap="round" d="M15.464 1.254c-.95.06-2.024.667-2.985 2.338-.9 1.566-1.67 2.33-2.437 2.416" /><path d="M3.323 1.675a.984.984 0 0 1 1.704 0l1.69 2.928a.984.984 0 0 1-.852 1.475h-3.38a.984.984 0 0 1-.852-1.475z" /></g></svg>;
}
;